import Vue from "vue";

Vue.filter("trim", (val, limit = 10, add = "") => {
  if (!val) return val;
  if (val.length <= limit) return val;
  return val.substring(0, limit) + add;
});
